<template>
    <div class="AuthSlider h-56 relative overflow-hidden md:h-72 lg:h-screen lg:w-3/5">
      <div
        class="slider-container absolute top-0 left-0 w-full h-full flex duration-500 transition-all ease-in-out"
        ref="sliderContainer"
      >
        <div
          class="bg-no-repeat bg-cover bg-center min-w-full min-h-full"
          :style="{ backgroundImage: [`url('${loginPage1}')`] }"
        ></div>
        <div
          class="bg-no-repeat bg-cover bg-center min-w-full min-h-full "
          :style="{ backgroundImage: [`url('${loginPage2}')`], backgroundPosition:'right' }"
        ></div>
      </div>
  
      <!--//v overlay -->
      <div class="AuthSlider-overlay absolute top-0 left-0 h-full w-full z-0"></div>
      <div class="p-3 flex flex-col h-full z-20 relative lg:px-16 lg:py-12">
        <img
          src="@/assets/logo-white.svg"
          alt="ask-a-fundraiser-logo-white"
          class="inline-block w-36 mb-auto md:w-40 lg:w-56"
        />
     
      </div>
    </div>
  </template>
  <script setup>
  import { ref, onMounted, onUnmounted } from "vue";
  
  const sliderContainer = ref(null);
  const interval = ref(null);
  const NumberOfSlides = 2;
  let activeSlideIndex = ref(0);
  
  import loginPage1 from "@/assets/login-page-1.jpg";
  import loginPage2 from "@/assets/login-page-2.jpg";
  
  onMounted(() => {
    interval.value = setInterval(() => changeSlide("up"), 5500);
  });
  
  onUnmounted(() => {
    //v Clean Interval
    window.clearInterval(interval.value);
  });
  
  const changeSlide = (direction) => {
    const sliderWidth = sliderContainer.value.clientWidth;
    if (direction === "up") {
      activeSlideIndex.value++;
      if (activeSlideIndex.value > NumberOfSlides - 1) {
        activeSlideIndex.value = 0;
      }
    }
  
    sliderContainer.value.style.transform = `translateX(-${activeSlideIndex.value * sliderWidth}px)`;
  };
  </script>
  
  <style scoped>
  .AuthSlider-overlay {
    background: linear-gradient(35.45deg, #0d423d 0.67%, rgba(13, 66, 61, 0) 100%);
    opacity: 0.8;
  }
  </style>
  